export default "__VITE_ASSET__BIqzaYVG__"